import { Box } from "@mui/material";

import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl } from "../../../../config";
import { AccountTypesColumns } from "../../../../data/DynamicTable/Collumns";
import {
  allBankAccounts,
  allFiscalYears,
  allTaxAuthorities,
  AllCurrency,
} from "../../../../data/Axios/queries";
import {
  
  CurrencyColumns
} from "../../../../data/DynamicTable/AccountsColumns";
import CurrencyForm from "./form";
const base_url = AccountsandFinanceurl.uri;
const actions = {
  entity: "Currency",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  ViewCurrencyLines:{ 
      key: "VIEWCURRENCYLINES", 
      button_name: "Currency Lines", 
      Show_Button: true, 
      permission: "hasNoPermission", 
      roleGroupId: [1, 2, 3, 4], 
      showStatus: true,
    },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  showStatus: true,
};
function CurrencyTable() {
  return (
    <Box m="2px">
      <DynamicTable
        title="Currency"
        subtitle="Create, view or edit currency
        "
        columns={CurrencyColumns}
        FormComponent={CurrencyForm}
        query={AllCurrency}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default CurrencyTable;
